export default "__VITE_ASSET__C$7fz5WV__"